import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminAiUsage = {
  index: async(props) => {
    const { default: AiUsageIndex } = await import('@/vue_widgets/admin/ai_usage/index.vue')
    createVueApp(AiUsageIndex, { props })
  }
}
